import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID,
    ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID,
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_FAILURE,
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_SUCCESS,

    ACTION_MONITORINGISSUEDOCUMENT_SAVE,
    ACTION_MONITORINGISSUEDOCUMENT_SAVE_SUCCESS,
    ACTION_MONITORINGISSUEDOCUMENT_SAVE_FAILURE,

    ACTION_MONITORINGISSUEDOCUMENT_CREATE,
    ACTION_MONITORINGISSUEDOCUMENT_CREATE_SUCCESS,
    ACTION_MONITORINGISSUEDOCUMENT_CREATE_FAILURE,

    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE,
    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_SUCCESS,
    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_FAILURE,

    ACTION_MONITORINGISSUEDOCUMENT_CLEAR,
    ACTION_MONITORINGISSUEDOCUMENT_FILTER,

    MonitoringIssueDocumentAction,
} from '../actions/monitoringIssueDocument';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IMonitoringIssueDocumentState {
    formData: Dtos.MonitoringIssueDocument | Dtos.MonitoringIssueDocument[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.MonitoringIssueDocument[];
    formLength: number;
}

const initialState: IMonitoringIssueDocumentState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: IMonitoringIssueDocumentState, _isLoading: boolean): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IMonitoringIssueDocumentState,
    formData: Dtos.MonitoringIssueDocument | Dtos.MonitoringIssueDocument[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: IMonitoringIssueDocumentState, responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: IMonitoringIssueDocumentState, formFilter: IFormFilter): IMonitoringIssueDocumentState {

    const items: Dtos.MonitoringIssueDocument[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IMonitoringIssueDocumentState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: IMonitoringIssueDocumentState, propertiesToClear?: string[]): IMonitoringIssueDocumentState {

    if (!propertiesToClear) {
        const newState: IMonitoringIssueDocumentState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IMonitoringIssueDocumentState, _isSaving: boolean): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IMonitoringIssueDocumentState,
    formData: Dtos.MonitoringIssueDocument | Dtos.MonitoringIssueDocument[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IMonitoringIssueDocumentState, responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IMonitoringIssueDocumentState, _isCreating: boolean): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IMonitoringIssueDocumentState,
    formData: Dtos.MonitoringIssueDocument,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IMonitoringIssueDocumentState, responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IMonitoringIssueDocumentState, _isValidating: boolean): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IMonitoringIssueDocumentState,
    formData: Dtos.MonitoringIssueDocument,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IMonitoringIssueDocumentState, responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentState {
    const newState: IMonitoringIssueDocumentState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}


const MonitoringIssueDocumentReducer: Reducer<IMonitoringIssueDocumentState> = (state: IMonitoringIssueDocumentState = initialState, action: MonitoringIssueDocumentAction) => {
    switch (action.type) {
        case ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID:
        case ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID:
            return loading(state, true);
        case ACTION_MONITORINGISSUEDOCUMENT_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_MONITORINGISSUEDOCUMENT_SAVE:
            return saving(state, true);
        case ACTION_MONITORINGISSUEDOCUMENT_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_CREATE:
            return creating(state, true);
        case ACTION_MONITORINGISSUEDOCUMENT_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_MONITORINGISSUEDOCUMENT_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_VALIDATE:
            return validating(state, true);
        case ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_MONITORINGISSUEDOCUMENT_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default MonitoringIssueDocumentReducer;